import { OptionType } from '@cognite/cogs.js';
import { ApiVersion } from 'hooks/projects';

export function getVersionSelectOptions(
  versions: ApiVersion[]
): OptionType<string>[] {
  return versions.map((version) => ({
    label: `v. ${version.version}`,
    value: version.version,
  }));
}

export function markOldVersion(
  versionOptions: OptionType<string>[],
  version: OptionType<string>
) {
  const lastIndex = versionOptions.length - 1;
  const lastVersion = versionOptions[lastIndex];
  if (lastVersion && lastVersion.value !== version?.value) {
    return {
      ...version,
      label: `${version.label} Old`,
    };
  }
  return version;
}
